import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@/components/Navigation/Buttons/StoreFinderButton/storeFinderButton.container"
    ).then((module) => ({
        default: module.StoreFinderButton
    }))
);
